export default "__VITE_ASSET__bAPtPkqg__"